import { render, staticRenderFns } from "./FundaIntroD.vue?vue&type=template&id=e2afb1c4&"
import script from "./FundaIntroD.vue?vue&type=script&lang=js&"
export * from "./FundaIntroD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports